const rankingItems = [
  { rank: 1, title: '热血江湖：风云再起', heat: '9.8', tag: '热血', chapters: '186话', trend: 'up' },
  { rank: 2, title: '异界幻想：元素使者', heat: '9.7', tag: '奇幻', chapters: '215话', trend: 'up' },
  { rank: 3, title: '甜蜜陷阱：恋爱百分百', heat: '9.6', tag: '恋爱', chapters: '132话', trend: 'up' },
  { rank: 4, title: '暗夜追踪：深渊之眼', heat: '9.5', tag: '悬疑', chapters: '98话', trend: 'stable' },
  { rank: 5, title: '都市传说：午夜画室', heat: '9.4', tag: '惊悚', chapters: '67话', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          热门排行
        </h2>
        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-50 rounded-lg transition-colors cursor-pointer group`}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-300 text-foreground-900'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium flex-shrink-0 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{item.chapters}</span>
                  <span className="flex items-center gap-1">
                    热度 {item.heat}
                    {item.trend === 'up' && (
                      <i className="ri-arrow-up-fill text-accent-500 text-xs"></i>
                    )}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-heading text-accent-500">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}